import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AiOnlyNarrationBlock } from '../../models/ai-assistant.models';

@Component({
  selector: 'app-response-only-narration',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-only-narration.component.html',
  styleUrl: './response-only-narration.component.css',
})
export class ResponseOnlyNarrationComponent {
  @Input({ required: true }) block!: AiOnlyNarrationBlock;
}
